export default [
    {
      path: '/landing-page',
      component: () => import('./views/Index'),
      name: 'landing-page',
      redirect: { name: 'landing-page-list' },
      children: [
        {
          path: '',
          name: 'landing-page-list',
          component: () => import('./views/List'),
          meta: {
            resource: 'auth',
          },
        },
        {
          path: ':id',
          name: 'landing-page-detail',
          component: () => import('./views/Detail'),
          meta: {
            resource: 'auth',
          },
        },
      ],
    },
  ]
  